module.exports = __webpack_public_path__ + "img/dango makers from the moon.97c9d28c.png";